import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/no_group.png'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  class: "searchbox",
  style: {"text-align":"left"}
}
const _hoisted_3 = { class: "table_div" }
const _hoisted_4 = { class: "left_phone" }
const _hoisted_5 = {
  key: 0,
  class: "master-phone"
}
const _hoisted_6 = { class: "master-phone_content" }
const _hoisted_7 = { class: "phone_id_div" }
const _hoisted_8 = ["readOnly"]
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "main_phones" }
const _hoisted_11 = { class: "top_btns" }
const _hoisted_12 = {
  key: 0,
  ref: "cloudsBoxRef",
  class: "clouds_box"
}
const _hoisted_13 = { class: "clouds_id_div" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "slave-screenshot-placeholder"
}
const _hoisted_17 = {
  key: 1,
  class: "clouds_box"
}
const _hoisted_18 = {
  class: "group-hidden-hosts",
  "aria-hidden": "true"
}
const _hoisted_19 = ["id"]
const _hoisted_20 = {
  key: 2,
  class: "no_phone"
}

import {
		Ref,
		ref,
		reactive,
		computed,
		onMounted,
		onUnmounted,
		getCurrentInstance,
		nextTick,
		watch
	} from 'vue';
	import {
		Close,
		Search,
		Refresh,
		CopyDocument,
		ArrowDown,
		ArrowUp
	} from '@element-plus/icons-vue';
	import {
		StreamClientScrcpy
	} from '@/app/googDevice/client/StreamClientScrcpy';
	import {
		openCloudPhoneStream
	} from '@/app/streaming/openCloudPhoneStream';
	import request from '@/utils'
	import {
		ElMessage
	} from 'element-plus';
	import {
		useStore
	} from 'vuex';
	import {
		BroadcastService
	} from '@/app/interactionHandler/BroadcastService';
	import { BroadcastBus } from '@/app/interactionHandler/BroadcastBus';
	import { KeyInputHandler, type KeyEventListener } from '@/app/googDevice/KeyInputHandler';

	// 定义类型
	interface Machine {
		id : number;
		ip : string;
		cpu : string;
		cpu_core : number;
		memory : number;
		volume : number;
		status : number;
		created_at : string;
		updated_at : string;
		mac_addr : string;
		volume_device : string;
	}

	interface Instance {
		id : number;
		machine_id : number;
		mac : string;
		ip : string;
		product_id : number;
		package_id : number;
		created_at : string;
		updated_at : string;
		status : number;
		is_realphone : number;
		adb_port : number;
		adb_address : string;
		height : number;
		width : number;
		image : string;
		image_tag : string;
		index : number;
		state : number;
		cpu_cores : number;
		memory : number;
		storage : number;
		name : string;
		machine : Machine;
	}

	interface CloudPhone {
		id : number;
		user_id : string;
		instance_id : number;
		start_time : string;
		expire_time : string;
		status : number;
		created_at : string;
		updated_at : string;
		order_id : number;
		image : string;
		image_tag : string;
		auto_renew : number;
		screen_shot : string;
		instance_name : string;
		instances : Instance;
		checked ?: boolean;
		is_trial ?: number;
		state : number;
		screen_shot_loading ?: boolean;
	}

	interface State {
		master_phone : CloudPhone[];
		drawer : boolean;
		activeName : string;
		check_cloud_id : string | null;
		clouds_list : CloudPhone[];
		otherphone_list : CloudPhone[];
		checked_phone_list : CloudPhone[];
		ws : WebSocket | null;
		StreamClientScrcpy_start : any;
		StreamClientScrcpy_start_list : any[];
		playerRegistrations : any[];
		connections : any;
		udids : any[];
	}

	interface CommitMsg { type : 'commit'; text ?: string; }
	interface DeleteMsg { type : 'delete'; count : number; text ?: string; }
	interface ReplaceMsg { type : 'replace'; text ?: string; }
	type InputMsg = CommitMsg | DeleteMsg | ReplaceMsg;

	const SYNC_SCREENSHOT_IDLE_INTERVAL = 3000;
	const SYNC_SCREENSHOT_ACTIVE_INTERVAL = 1000;
	const SYNC_OPERATION_IDLE_TIMEOUT_MS = 20000;
	
export default /*@__PURE__*/_defineComponent({
  __name: 'GroupControl',
  setup(__props) {

	const store = useStore();
	const appRouter = getCurrentInstance()?.appContext.config.globalProperties.$router;

	const state = reactive<State>({
		master_phone: [],
		drawer: true,
		activeName: 'first',
		check_cloud_id: null,
		clouds_list: [],
		otherphone_list: [],
		checked_phone_list: [],
		ws: null,
		StreamClientScrcpy_start: null,
		StreamClientScrcpy_start_list: [],
		playerRegistrations: [],
		connections: null,
		udids: []
	});

	onUnmounted(() => {
		disableScreenshotSyncMode();
		BroadcastService.getInstance().unregisterClient();
		clearImeEvents();
	})

	class WebSocketManager {
		private connections : Map<string, any>;
		private players : Map<string, any>;

		constructor() {
			this.connections = new Map();
			this.players = new Map();
		}

		// 建立单个连接
		async connect(
			device : CloudPhone,
			is_tool : boolean,
			ScreenW : number,
			ScreenH : number,
			zoomsize : number,
			bitrate: number,
			is_master_cloud : boolean
		) : Promise<any> {
			try {
				const udid = `${device.instances.machine.ip}:${device.instances.adb_port}`;
				if (!is_master_cloud) {
					// 从机：无论 ws_room 还是 ws_scrcpy，都走完整 openCloudPhoneStream 挂到隐藏 host。
					// 画面在 UI 上不显示（靠 /rtc/update_screenshot_config + 截图 img 替代），
					// 但必须保留 FeaturedInteractionHandler 以订阅 BroadcastBus 接收主控广播。
					await initPlayers(ScreenW, ScreenH, zoomsize, bitrate);
					state.StreamClientScrcpy_start = await openCloudPhoneStream({
						phone: device as any,
						showToolBox: false,
						isMasterCloud: false,
						sourceType: 'group_control',
					});
					state.StreamClientScrcpy_start_list.push(state.StreamClientScrcpy_start);
					BroadcastService.getInstance().registerClient(state.StreamClientScrcpy_start as any);
					console.info(`[groupControl] 从机已建立(隐藏拉流): ${udid} mode=${(state.StreamClientScrcpy_start as any)?.mode}`);
					return state.StreamClientScrcpy_start;
				}
				// 主机：完整拉流 + 工具条
				await initPlayers(ScreenW, ScreenH, zoomsize, bitrate);
				state.StreamClientScrcpy_start = await openCloudPhoneStream({
					phone: device as any,
					showToolBox: is_tool,
					isMasterCloud: is_master_cloud,
					sourceType: 'group_control',
				});
				state.StreamClientScrcpy_start_list.push(state.StreamClientScrcpy_start);
				BroadcastService.getInstance().registerClient(state.StreamClientScrcpy_start as any);
				// 触摸 / 按键 / 滚轮的跨机广播由 FeaturedInteractionHandler 通过 BroadcastBus 完成，
				// 从机端在 handleBroadcastMessage 里按各自 screenInfo 重算坐标，不再需要在这里包装 sendMessage。
				// 这里只挂一个活动回调，用于主控操作时把截图刷新率临时切到 1s。
				(window as any).__onGroupMasterActivity = () => {
					if (state.otherphone_list.length) markSyncOperationActive();
				};
				const player = state.StreamClientScrcpy_start?.getPlayer();
				// 主控启用本地键盘：先 false 再 true 触发 store watch，从而让 bindImeEvents 在 imeRef 已挂载后生效
				try {
					state.StreamClientScrcpy_start?.setHandleKeyboardEvents(false);
					await nextTick();
					setTimeout(() => {
						state.StreamClientScrcpy_start?.setHandleKeyboardEvents(true);
						const checkbox = document.getElementById(`input_capture_keyboard_${udid}_${player?.getName()}`) as HTMLInputElement | null;
						if (checkbox) checkbox.checked = true;
						imeRef.value?.focus();
					}, 300);
				} catch (err) {
					console.warn('[groupControl] 启用主控本地键盘失败:', err);
				}
				return state.StreamClientScrcpy_start;
			} catch (error) {
				console.error(`连接设备 ${device?.instances?.machine?.ip} 失败:`, error);
				throw error;
			}
		}

		async connectMultiple(
			devices : CloudPhone[],
			is_tool : boolean,
			ScreenW : number,
			ScreenH : number,
			zoomsize : number,
			bitrate: number,
			is_master_cloud : boolean
		) : Promise<Array<{ deviceId : string; status : string; player ?: any; error ?: string }>> {
			const results = [];
			for (const item of devices) {
				try {
          let width:number=item.instances.width
          let height:number=item.instances.height
          if (is_master_cloud) {
            width=ScreenW
            height=ScreenH
            bitrate=2388608
          }else{
            width=width*0.2
            height=height*0.2
          }
 					const player = await this.connect(
						item,
						is_tool,
						width,
						height,
						zoomsize,
						bitrate,
						is_master_cloud
					);
					results.push({
						deviceId: item.instances.machine.ip,
						status: 'connected',
						player
					});
				} catch (error : any) {
					results.push({
						deviceId: item.instances.machine.ip,
						status: 'error',
						error: error.message
					});
				}
			}
			return results;
		}

		// 获取所有Player实例（同步方法）
		getAllPlayers() : any[] {
			return Array.from(this.players.values());
		}
	}

	const wsManager = ref<WebSocketManager>(new WebSocketManager());

	// ========== 截图同步（从机不拉流，靠截图展示） ==========
	const slaveScreenshots = ref<Record<number, string>>({});
	const slaveScreenshotBase = ref<Record<number, string>>({});
	const currentScreenshotIntervalMs = ref<number | null>(null);
	const screenshotPollingTimer = ref<ReturnType<typeof setInterval> | null>(null);
	const syncOperationIdleTimer = ref<ReturnType<typeof setTimeout> | null>(null);
	const getFollowerPhoneIds = () : number[] => state.otherphone_list.map((p) => p.id);
	const getSlaveScreenshotUrl = (phone : CloudPhone) : string => {
		return slaveScreenshots.value[phone.id] || '';
	};
	const onSlaveScreenshotError = (e : Event) => {
		const img = e.target as HTMLImageElement;
		if (img) img.src = '';
	};
	const buildScreenshotBase = (raw : string) : string => {
		if (!raw) return '';
		// 去掉旧的 timestamp query，避免越积越长
		const base = raw.includes('?') ? raw.split('?')[0] : raw;
		return base.includes('http') ? base : `${store.state.request_url}${base}`;
	};
	const cacheSlaveScreenshotBases = () => {
		const next : Record<number, string> = {};
		for (const p of state.otherphone_list) {
			if ((p as any).screen_shot) {
				next[p.id] = buildScreenshotBase((p as any).screen_shot);
			}
		}
		slaveScreenshotBase.value = next;
	};
	const updateScreenshotSyncMode = async (enabled : boolean, ids : number[], interval ?: number) => {
		if (!ids.length) return;
		const payload : any = { instance_use_ids: ids, sync_mode: enabled };
		if (enabled) {
			payload.upload_interval = interval ?? SYNC_SCREENSHOT_IDLE_INTERVAL;
			payload.upload_quality = (interval ?? SYNC_SCREENSHOT_IDLE_INTERVAL) <= SYNC_SCREENSHOT_ACTIVE_INTERVAL ? 24 : 28;
			payload.max_long_edge = 420;
		}
		try {
			await request.post('/rtc/update_screenshot_config', payload);
		} catch (error) {
			console.error('更新截图同步配置失败:', error);
		}
	};
	const refreshSlaveScreenshots = () => {
		// 只更新 timestamp 触发浏览器重新取图，不再请求 /containers/list
		if (!state.otherphone_list.length) return;
		const ts = Date.now();
		const next : Record<number, string> = { ...slaveScreenshots.value };
		for (const id of Object.keys(slaveScreenshotBase.value)) {
			const phoneId = Number(id);
			const base = slaveScreenshotBase.value[phoneId];
			if (base) next[phoneId] = `${base}?t=${ts}`;
		}
		slaveScreenshots.value = next;
	};
	const startScreenshotPolling = (intervalMs : number) => {
		stopScreenshotPolling();
		screenshotPollingTimer.value = setInterval(refreshSlaveScreenshots, intervalMs);
		// 立刻刷一次
		refreshSlaveScreenshots();
	};
	const stopScreenshotPolling = () => {
		if (screenshotPollingTimer.value) {
			clearInterval(screenshotPollingTimer.value);
			screenshotPollingTimer.value = null;
		}
	};
	const applyScreenshotInterval = async (intervalMs : number, reason : string) => {
		if (currentScreenshotIntervalMs.value === intervalMs) return;
		currentScreenshotIntervalMs.value = intervalMs;
		const ids = getFollowerPhoneIds();
		if (!ids.length) return;
		await updateScreenshotSyncMode(true, ids, intervalMs);
		startScreenshotPolling(intervalMs);
		console.info(`[groupControl] screenshot interval=${intervalMs}ms reason=${reason}`);
	};
	const clearSyncOperationIdleTimer = () => {
		if (syncOperationIdleTimer.value) {
			clearTimeout(syncOperationIdleTimer.value);
			syncOperationIdleTimer.value = null;
		}
	};
	const markSyncOperationActive = () => {
		if (!state.otherphone_list.length) return;
		applyScreenshotInterval(SYNC_SCREENSHOT_ACTIVE_INTERVAL, 'operation_active');
		clearSyncOperationIdleTimer();
		syncOperationIdleTimer.value = setTimeout(() => {
			applyScreenshotInterval(SYNC_SCREENSHOT_IDLE_INTERVAL, 'operation_idle');
		}, SYNC_OPERATION_IDLE_TIMEOUT_MS);
	};
	const disableScreenshotSyncMode = async () => {
		clearSyncOperationIdleTimer();
		stopScreenshotPolling();
		const ids = getFollowerPhoneIds();
		if (ids.length) {
			try { await updateScreenshotSyncMode(false, ids); } catch (_e) {}
		}
		currentScreenshotIntervalMs.value = null;
		slaveScreenshots.value = {};
		slaveScreenshotBase.value = {};
	};
	// ========== end 截图同步 ==========

	async function Group_control() : Promise<void> {
		if (state.checked_phone_list.length > 0) {
			state.udids = []
			const primaryDevice = state.checked_phone_list[0];
			state.master_phone.push(primaryDevice);
			const hasRemainingDevices = state.checked_phone_list.length > 1;

			if (hasRemainingDevices) {
				state.otherphone_list = state.checked_phone_list.slice(1);
				cacheSlaveScreenshotBases();
				// 等 Vue 渲染出隐藏 host 节点，stream client 才能挂载
				await nextTick();
				await wsManager.value.connectMultiple(state.otherphone_list, false, 1080, 1920, 0.2,1388608,false);
			}

			await wsManager.value.connectMultiple(state.master_phone, true, 1080, 1920, 0.4,5388608, true);
			state.drawer = false;
			// 从机改为截图模式：调 /rtc/update_screenshot_config 开启上传，并以空闲频率启动轮询
			if (hasRemainingDevices) {
				await applyScreenshotInterval(SYNC_SCREENSHOT_IDLE_INTERVAL, 'group_started');
			}
		}
	}

	initdata(); //渲染前执行请求

	function initdata() : void {
		get_clouds();
	}

	function Copy_text(text : string) : Promise<void> {
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard 向剪贴板写文本
			return navigator.clipboard.writeText(text)
		} else {
			// 创建text area
			const textArea = document.createElement('textarea')
			textArea.value = text
			// 使text area不在viewport，同时设置不可见
			document.body.appendChild(textArea)
			textArea.focus()
			textArea.select()
			return new Promise<void>((res, rej) => {
				// 执行复制命令并移除文本框
				document.execCommand('copy') ? res() : rej()
				textArea.remove()
			})
		}
	}

	//获取当前用户的所有云手机
	function get_clouds() : void {
		const response = request.get('/containers/list');
		response.then((res : any) => {
			state.clouds_list = res.data.data;
		}).catch(() => { });
	}

	const headerRowStyle = ({ row, rowIndex } : { row : any; rowIndex : number }) : { [key : string] : string } => {
		return {
			backgroundColor: '#f0f3f5', // 背景色
			color: '#212224', // 文字颜色
		};
	};

	const querySearch = (queryString : string, callback : (results : CloudPhone[]) => void) : void => {
		const results = queryString
			? state.clouds_list.filter(item =>
				item.instances.name.toLowerCase().includes(queryString.toLowerCase())
			)
			: state.clouds_list;
		callback(results); // 返回筛选结果
	};
	//关闭并退出群控页面
	async function closeOverlay() : Promise<void> {
		await disableScreenshotSyncMode();
		BroadcastService.getInstance().unregisterClient()
		appRouter?.back();
	}

	//切换主设备
	const change_master_phone = async (cloud_value : CloudPhone, index : number) : Promise<void> => {
		clearSyncOperationIdleTimer();
		stopScreenshotPolling();
		BroadcastService.getInstance().unregisterClient();
		state.StreamClientScrcpy_start_list = []
		state.udids = []
		const other_phone = JSON.parse(JSON.stringify(state.master_phone[0]));
		state.master_phone[0] = cloud_value;
		state.otherphone_list[index] = other_phone;
		cacheSlaveScreenshotBases();
		await nextTick();
		await wsManager.value.connectMultiple(state.master_phone, true, 1280, 1920, 0.4,5388608,true);
		await wsManager.value.connectMultiple(state.otherphone_list, false, 1280, 1920, 0.2,1388608,false);
		currentScreenshotIntervalMs.value = null;
		await applyScreenshotInterval(SYNC_SCREENSHOT_IDLE_INTERVAL, 'master_switched');
	};

	const handleSelect = (item : CloudPhone) : void => {
		state.check_cloud_id = item.instances.name;
	};

	// 初始化播放器
	const initPlayers = async (ScreenW : number, ScreenH : number, zoomsize : number,bitrate: number) : Promise<void> => {
		const { MsePlayer } = await import('@/app/player/MsePlayer');
		StreamClientScrcpy.registerPlayer(MsePlayer);
		const { WebCodecsPlayer } = await import('@/app/player/WebCodecsPlayer');
		StreamClientScrcpy.registerPlayer(WebCodecsPlayer);
		MsePlayer.resize(ScreenW, ScreenH, zoomsize,bitrate); //改变当前云手机屏幕的宽高和屏幕点击(x,y)缩放的大小
	};

	function handleSelectionChange(val : CloudPhone[]) : void {
		state.checked_phone_list = val;
	}

	const imeRef = ref<HTMLInputElement | null>(null);
	let lastSent = "";
	let isEventsBound = false;
	let keyInputListener : KeyEventListener | null = null;
	let isComposing = ref(false); // 改用ref，确保响应式（之前是普通变量，可能有延迟）

	const currentPhone = ref<CloudPhone | null>(null);
	const showOverlay = ref(true);
	const ws = ref<WebSocket | null>(null);
	// 根据"同步操作"开关返回需要接收文本/按键的目标客户端：同步开 → 全部；同步关 → 只有 master
	const getSyncTargetClients = () : any[] => {
		const clients = state.StreamClientScrcpy_start_list as any[];
		if (store.state.is_sync) return clients;
		if (!state.master_phone[0]?.instances?.machine || !state.master_phone[0]?.instances?.adb_port) {
			return clients;
		}
		const masterUdid = `${state.master_phone[0].instances.machine.ip}:${state.master_phone[0].instances.adb_port}`;
		return clients.filter((c) => c?.getPlayer?.()?.udid === masterUdid);
	};
	// 当前主控客户端（从 StreamClient 列表里按 master udid 定位）
	const getMasterClient = () : any => {
		if (!state.master_phone[0]?.instances?.machine) return null;
		const masterUdid = `${state.master_phone[0].instances.machine.ip}:${state.master_phone[0].instances.adb_port}`;
		return state.StreamClientScrcpy_start_list.find((c : any) => c?.getPlayer?.()?.udid === masterUdid) || null;
	};
	// 广播 IME 文本到从机（PC 的 broadcastImeText 对应实现）
	const broadcastImeText = (text : string) : void => {
		const master = getMasterClient();
		if (!master) return;
		const masterUdid = master.getPlayer?.()?.udid;
		if (!masterUdid) return;
		BroadcastBus.getInstance().emit({
			sourcePhoneId: masterUdid,
			groupId: 'default',
			message: { type: 'ime_text', sourcePhoneId: masterUdid, timestamp: Date.now(), data: { text } },
			timestamp: Date.now(),
		});
		try { (window as any).__onGroupMasterActivity?.(); } catch (_e) {}
	};
	// 广播功能键（Enter/Tab/Arrow...）到从机，从机端 executeKeyEvent → listener.sendKeyEvent(code, action, metaState)
	const broadcastFunctionKey = (code : string, action : 'down' | 'up', metaState : number) : void => {
		const master = getMasterClient();
		if (!master) return;
		const masterUdid = master.getPlayer?.()?.udid;
		if (!masterUdid) return;
		BroadcastBus.getInstance().emit({
			sourcePhoneId: masterUdid,
			groupId: 'default',
			message: {
				type: 'key',
				sourcePhoneId: masterUdid,
				timestamp: Date.now(),
				data: { code, action, metaState },
			},
			timestamp: Date.now(),
		});
		try { (window as any).__onGroupMasterActivity?.(); } catch (_e) {}
	};

	//中文和粘贴广播内容
	function sendMsg(msg : InputMsg) : void {
		if (!state.master_phone[0].id) return;
		const clients = getSyncTargetClients();
		const wsRoomClients = clients.filter((c) => c?.mode === 'ws_room');
		const scrcpyClients = clients.filter((c) => c?.mode !== 'ws_room');
		// ws_room 客户端：通过 WebSocket 直接下发 IME / 退格，不走 HTTP
		if (wsRoomClients.length) {
			wsRoomClients.forEach((c) => {
				if (msg.type === 'delete') {
					const count = Math.max(1, (msg as DeleteMsg).count || 1);
					for (let i = 0; i < count; i++) {
						c.sendBackspaceKey?.();
					}
				} else if (msg.text) {
					c.sendImeText?.(msg.text);
				}
			});
		}
		if (!scrcpyClients.length) {
			if (!isComposing.value) {
				KeyInputHandler.setWebSocketEnabled(true);
			}
			return;
		}
		state.udids = scrcpyClients.map((c) => c.getPlayer()?.udid).filter(Boolean);
		const requestData = { udids: state.udids, text: msg.text };
		request.post('/containers/batch_transfer_text', requestData).then(() => {
			if (!isComposing.value) {
				KeyInputHandler.setWebSocketEnabled(true);
			}
		}).catch(() => { });
	}

	// 初始化时设为false，避免初始状态异常
	const handleCompositionStart = (e : Event) : void => {
		const ev = e as CompositionEvent;
		isComposing.value = true;
		KeyInputHandler.setWebSocketEnabled(false);
		e.stopImmediatePropagation();
		e.preventDefault();
	};

	const handleCompositionEnd = (e : Event) : void => {
		const ev = e as CompositionEvent;
		const chineseText = ev.data?.trim();
		setTimeout(() => {
			isComposing.value = false;
			KeyInputHandler.setWebSocketEnabled(true);
		}, 100); // 延迟100ms，避免选字后立即触发英文输入
		if (chineseText && store.state.Phone_Local_keyboard_flag && imeRef.value) {
			const msg : CommitMsg = { type: 'commit', text: chineseText };
			sendMsg(msg);
			imeRef.value.value = "";
			lastSent = "";
		}
	};

	// 修改 handleInput - 处理英文字符输入
	const handleInput = (e : Event) : void => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const inputEvent = e as InputEvent;
		const newValue = imeRef.value.value;

		if (isComposing.value) return;
		if (newValue.length > lastSent.length) {
			const newChars = newValue.slice(lastSent.length);
			const master = getMasterClient();
			const masterIsWsRoom = master?.mode === 'ws_room';

			for (const char of newChars) {
				// 特殊符号 ?/ 统一走 transfer_text
				if (char === '?' || char === '/') {
					sendSymbolAsText(char);
					continue;
				}
				if (char >= ' ' && char <= '~') {
					// 主控本机执行
					if (masterIsWsRoom) {
						master?.sendImeText?.(char);
					} else if (master) {
						// ws_scrcpy master：走 KeyInputHandler（仅主控订阅此 handler）→ 会命中 Gboard，同 PC 行为
						KeyInputHandler.sendCharacter(char);
					}
					// 同步从机：通过 BroadcastBus 发 ime_text，ws_room 从机走 sendImeText，ws_scrcpy 从机走 /containers/transfer_text
					if (store.state.is_sync) {
						broadcastImeText(char);
					}
				}
			}
			lastSent = newValue;
		} else if (newValue.length < lastSent.length) {
			lastSent = newValue;
		}
	};

	// 👇 新增：直接发送 ?/ 到云手机输入框（复用中文输入的文本接口）
	const sendSymbolAsText = (symbol : string) : void => {
		const clients = getSyncTargetClients();
		const wsRoomClients = clients.filter((c) => c?.mode === 'ws_room');
		const scrcpyClients = clients.filter((c) => c?.mode !== 'ws_room');
		if (wsRoomClients.length) {
			wsRoomClients.forEach((c) => c.sendImeText?.(symbol));
		}
		if (!scrcpyClients.length) return;
		if (!currentPhone.value?.instances?.machine || !currentPhone.value?.instances?.adb_port) {
			ElMessage.error('云手机信息不完整，无法发送符号');
			return;
		}
		const currentPhoneUdid = `${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`;
		const requestData = {
			udid: currentPhoneUdid,
			text: symbol
		};
		request.post('/containers/transfer_text', requestData)
			.then(() => { })
			.catch(() => { });
	};

	// 修改 handleKeyDown 方法，添加 CapsLock 处理
	const handleKeyDown = (e : KeyboardEvent) : void => {
		if (!store.state.Phone_Local_keyboard_flag || isComposing.value) return;

		// 👇 新增：处理 CapsLock 键按下
		if (e.key === 'CapsLock') {
			e.preventDefault(); // 阻止浏览器默认行为（避免本地输入法干扰）
			KeyInputHandler.sendKeyEvent(e.code, 'down', 0); // metaState=0（无需修饰键）
			return;
		}

		// 原有退格键处理
		if (e.key === 'Backspace') {
			e.preventDefault();
			const master = getMasterClient();
			const masterIsWsRoom = master?.mode === 'ws_room';
			// 主控本机执行
			if (masterIsWsRoom) {
				master?.sendBackspaceKey?.();
			} else if (master) {
				KeyInputHandler.sendBackspaceKey();
			}
			// 同步从机
			if (store.state.is_sync) {
				const master = getMasterClient();
				const masterUdid = master?.getPlayer?.()?.udid;
				if (masterUdid) {
					BroadcastBus.getInstance().emit({
						sourcePhoneId: masterUdid,
						groupId: 'default',
						message: {
							type: 'button_key_event',
							sourcePhoneId: masterUdid,
							timestamp: Date.now(),
							action: 0, keycode: 67, metaState: 0, repeat: 0,
						},
						timestamp: Date.now(),
					});
					BroadcastBus.getInstance().emit({
						sourcePhoneId: masterUdid,
						groupId: 'default',
						message: {
							type: 'button_key_event',
							sourcePhoneId: masterUdid,
							timestamp: Date.now(),
							action: 1, keycode: 67, metaState: 0, repeat: 0,
						},
						timestamp: Date.now(),
					});
				}
			}
			return;
		}

		// 其他功能键（保留原有）
		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'down', metaState);
			if (store.state.is_sync) broadcastFunctionKey(e.code, 'down', metaState);
		}
	};

	// 修改 handleKeyUp 方法，添加 CapsLock 处理
	const handleKeyUp = (e : KeyboardEvent) : void => {
		if (isComposing.value || !store.state.Phone_Local_keyboard_flag) {
			e.stopPropagation();
			e.preventDefault();
			return;
		}

		// 👇 新增：处理 CapsLock 键释放
		if (e.key === 'CapsLock') {
			e.preventDefault();
			KeyInputHandler.sendKeyEvent(e.code, 'up', 0); // metaState=0
			return;
		}

		// 其他功能键（保留原有）
		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'up', metaState);
			if (store.state.is_sync) broadcastFunctionKey(e.code, 'up', metaState);
		}
	};

	const handlePaste = (e : Event) : void => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const ev = e as ClipboardEvent;
		ev.preventDefault();
		const pastedText = ev.clipboardData?.getData('text');
		if (pastedText) {
			const msg : CommitMsg = { type: 'commit', text: pastedText };
			sendMsg(msg);
			imeRef.value.value = "";
		}
	};

	const handleFocus = (e : Event) : void => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		lastSent = imeRef.value.value;
	};

	const handleBlur = (e : Event) : void => {
		isComposing.value = false;
		KeyInputHandler.setWebSocketEnabled(true);
	};

	const bindImeEvents = () : void => {
		const inp = imeRef.value;
		if (!inp || !store.state.Phone_Local_keyboard_flag || isEventsBound) return;
		inp.addEventListener('input', handleInput);
		inp.addEventListener('keydown', handleKeyDown); // 捕获阶段拦截
		inp.addEventListener('compositionstart', handleCompositionStart);
		inp.addEventListener('compositionend', handleCompositionEnd);
		inp.addEventListener('keyup', handleKeyUp);
		inp.addEventListener('paste', handlePaste);
		inp.addEventListener('focus', handleFocus);
		inp.addEventListener('blur', handleBlur);
		keyInputListener = {
			onKeyEvent: (message) => {
				if (ws.value && ws.value.readyState === WebSocket.OPEN) {
					ws.value.send(JSON.stringify(message));
				}
			}
		};
		KeyInputHandler.addEventListener(keyInputListener);
		isEventsBound = true;
		inp.focus();
		setTimeout(() => inp.focus(), 100);
	};

	const clearImeEvents = () : void => {
		const inp = imeRef.value;
		if (!inp || !isEventsBound) return;
		inp.removeEventListener('keydown', handleKeyDown);
		inp.removeEventListener('input', handleInput);
		inp.removeEventListener('compositionstart', handleCompositionStart);
		inp.removeEventListener('compositionend', handleCompositionEnd);
		inp.removeEventListener('keyup', handleKeyUp);
		inp.removeEventListener('paste', handlePaste);
		inp.removeEventListener('focus', handleFocus);
		inp.removeEventListener('blur', handleBlur);
		if (keyInputListener) {
			KeyInputHandler.removeEventListener(keyInputListener);
			keyInputListener = null;
		}

		isEventsBound = false;
		isComposing.value = false;
		lastSent = "";
		inp.value = "";
	};
	// 合并两个 watch 监听器
	watch(() => store.state.Phone_Local_keyboard_flag, (isEnabled) => {
		const inp = imeRef.value;

		if (isEnabled && showOverlay.value) {
			bindImeEvents();
		} else {
			// 执行两个 else 分支的逻辑
			clearImeEvents();
			if (inp) {
				inp.value = "";
				isComposing.value = false;
				KeyInputHandler.setWebSocketEnabled(true);
			}
		}
	}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: state.drawer,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.drawer) = $event)),
      size: "40%",
      "close-on-click-modal": false,
      "footer-class": "drawer_footer"
    }, {
      header: _withCtx(() => [...(_cache[8] || (_cache[8] = [
        _createElementVNode("span", { style: {"text-align":"left"} }, "选择云手机", -1)
      ]))]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          color: "#0079f2",
          size: "large",
          onClick: Group_control
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("开始群控", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_autocomplete, {
              modelValue: state.check_cloud_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.check_cloud_id) = $event)),
              "fetch-suggestions": querySearch,
              "popper-class": "my-autocomplete",
              placeholder: "请输入云机ID",
              onSelect: handleSelect,
              style: {"width":"240px"}
            }, {
              default: _withCtx(({ item }: { item: CloudPhone }) => [
                _createElementVNode("div", null, _toDisplayString(item.instances.name), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              color: "#0079f2",
              icon: _unref(Search),
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("查询", -1)
              ]))]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              icon: _unref(Refresh),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (state.check_cloud_id=''))
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("重置", -1)
              ]))]),
              _: 1
            }, 8, ["icon"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_tabs, {
              modelValue: state.activeName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.activeName) = $event)),
              class: "demo-tabs"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "全部分组",
                  name: "first"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      data: state.clouds_list,
                      "header-cell-style": headerRowStyle,
                      onSelectionChange: handleSelectionChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "selection",
                          width: "55"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "instances.name",
                          label: "云机ID"
                        }),
                        _createVNode(_component_el_table_column, {
                          property: "instance_name",
                          label: "云机名称"
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_4, [
      (state.master_phone.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("input", {
                  id: "ime",
                  ref_key: "imeRef",
                  ref: imeRef,
                  style: {"position":"absolute","top":"20%","opacity":"0"},
                  readOnly: !_unref(store).state.Phone_Local_keyboard_flag
                }, null, 8, _hoisted_8),
                _createElementVNode("p", null, [
                  _createElementVNode("span", null, _toDisplayString(state.master_phone[0].instance_name || `云机${state.master_phone[0].id}`), 1),
                  _createTextVNode("(" + _toDisplayString(state.master_phone[0].instances.name) + ") ", 1)
                ]),
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  size: "20",
                  color: "#0079f2",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (Copy_text(state.master_phone[0].instances.name)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CopyDocument))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                id: `phone-display-${state.master_phone[0].instances.machine.ip}:${state.master_phone[0].instances.adb_port}`,
                class: "master-phone-view"
              }, null, 8, _hoisted_9)
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[12] || (_cache[12] = _createElementVNode("div", null, null, -1))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_checkbox, {
            modelValue: _unref(store).state.is_sync,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(store).state.is_sync) = $event)),
            label: "同步操作",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_unref(store).commit('change_is_sync', $event)))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", null, "已选中 " + _toDisplayString(state.checked_phone_list.length), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            color: "#0079f2",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (state.drawer=true))
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("选择云手机", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_icon, {
            size: 20,
            style: {"margin-left":"20px","cursor":"pointer"},
            onClick: _withModifiers(closeOverlay, ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      (state.otherphone_list.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.otherphone_list, (cloud_value, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: cloud_value.id
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", null, [
                    _createElementVNode("span", null, _toDisplayString(cloud_value.instance_name || `云机${cloud_value.id}`), 1)
                  ]),
                  _createVNode(_component_el_icon, {
                    style: {"cursor":"pointer"},
                    size: "16",
                    color: "#0079f2",
                    onClick: ($event: any) => (Copy_text(cloud_value.instances.name))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CopyDocument))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", {
                  class: "slave-screenshot",
                  onClick: ($event: any) => (change_master_phone(cloud_value,index))
                }, [
                  (getSlaveScreenshotUrl(cloud_value))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: getSlaveScreenshotUrl(cloud_value),
                        class: "slave-screenshot-img",
                        alt: "slave preview",
                        onError: onSlaveScreenshotError
                      }, null, 40, _hoisted_15))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, "加载中..."))
                ], 8, _hoisted_14)
              ]))
            }), 128))
          ], 512))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[14] || (_cache[14] = [
            _createElementVNode("div", null, null, -1)
          ]))])),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.otherphone_list, (phone) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `hidden-${phone.id}`,
            id: `phone-display-${phone.instances.machine.ip}:${phone.instances.adb_port}`,
            class: "group-hidden-host"
          }, null, 8, _hoisted_19))
        }), 128))
      ]),
      (state.master_phone.length==0 && state.otherphone_list.length==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("div", null, [
              _createElementVNode("img", { src: _imports_0 }),
              _createElementVNode("p", null, "暂无云机")
            ], -1)
          ]))]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})